import React from 'react';
import { ServiceNodeGroup } from '@bumble/app/__generated__/data-contracts';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

export const ServiceNodeGroupEnableCert = ({
  group,
  onSubmit,
}: {
  group: ServiceNodeGroup;
  onSubmit: () => void;
}) => {
  const api = useApi();
  const [serverCert, setServerCert] = React.useState('');
  const [privateKey, setPrivateKey] = React.useState('');
  const [caChain, setCaChain] = React.useState('');

  const enableCert = useMutation(api.enableExternalCertificateApiV1EnableExternalCertificatePost, {
    onSuccess() {
      toast.success('Updated Endpoint Agent Details successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    enableCert.mutate({
      service_node_group_id: group.service_node_group_id,
      certificate: serverCert,
      private_key: privateKey,
      ca_chain: caChain,
    });
  };

  return (
    <Box pt={2}>
      <TextField
        fullWidth
        label="Node Group Id"
        variant="outlined"
        value={group.service_node_group_id}
        sx={{ mb: 4 }}
        disabled
      />
      <TextField
        fullWidth
        label="Node Group Name"
        variant="outlined"
        value={group.service_node_group_name}
        sx={{ mb: 4 }}
        disabled
      />
      <TextField
        fullWidth
        required
        multiline
        minRows={3}
        maxRows={5}
        label="Server Certificate"
        variant="outlined"
        value={serverCert}
        onChange={(e) => setServerCert(e.target.value)}
        placeholder="-----BEGIN CERTIFICATE----- XXXXX -----END CERTIFICATE-----"
        helperText="PEM-formatted certificate you wish to import."
        sx={{ mb: 4 }}
        autoFocus
      />

      <TextField
        fullWidth
        required
        multiline
        minRows={3}
        maxRows={5}
        label="Private Key"
        variant="outlined"
        value={privateKey}
        onChange={(e) => setPrivateKey(e.target.value)}
        placeholder="-----BEGIN PRIVATE KEY----- XXXXX -----END PRIVATE KEY-----"
        helperText="PEM-formatted, unencrypted private key of the certificate."
        sx={{ mb: 4 }}
        autoFocus
      />

      <TextField
        fullWidth
        required
        multiline
        minRows={3}
        maxRows={5}
        label="CA Chain"
        variant="outlined"
        value={caChain}
        onChange={(e) => setCaChain(e.target.value)}
        helperText="PEM-formatted CA chain associated with your certificate."
        sx={{ mb: 4 }}
      />

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
